import { RequestMainService } from "../request";

export class SingerService {
  static async getList(params: any = {}) {
    return RequestMainService.get(`/admin/singers`, params).then(
      ({ result }) => {
        return {
          count: result?.total,
          data: result.singers,
        };
      }
    );
  }

  static async delete(id: string | number) {
    return RequestMainService.delete(`/admin/singers/${id}`);
  }

  static async import(params: any) {
    return RequestMainService.uploadFile(`/admin/singers/import`, params).then(
      (res) => res?.data
    );
  }
}
